// const serverLocation = "http://localhost:9084";
const serverLocation = "https://www.boysboysboysboys.com/api/spin_the_wheel";

export async function listSpinners() {
  const response = await makeGetRequest("list_spinners");

  if (!response.ok) {
    console.error(`Could not list spinners - ${await response.text()}`);
    return [];
  }

  return response.json();
}

export async function getSpinnerId(spinnerName) {
  const response = await makePostRequest("get_spinner_id", {
    spinner_name: spinnerName,
  });

  if (!response.ok) {
    console.error(`Could not get spinner id - ${await response.text()}`);
    return undefined;
  }

  return response.text();
}

export async function getSpinnerName(spinnerId) {
  const response = await makePostRequest("get_spinner_name", {
    spinner_id: spinnerId,
  });

  if (!response.ok) {
    console.error(`Could not get spinner name - ${await response.text()}`);
    return undefined;
  }

  return response.text();
}

export async function listEntries(spinnerId) {
  const response = await makePostRequest("list_entries", {
    spinner_id: spinnerId,
  });

  if (!response.ok) {
    console.error(`Could not list spinner entries - ${await response.text()}`);
    return [];
  }

  return response.json();
}

export async function addSpinner(spinnerName, spinnerEntries) {
  const response = await makePostRequest("add_spinner", {
    spinner_name: spinnerName,
    spinner_entries: spinnerEntries,
  });

  if (!response.ok) {
    console.error(`Could not add spinner - ${await response.text()}`);
  }

  const spinnerId = await response.json().then((r) => r.spinner_id);
  return [response.ok, spinnerId];
}

export async function deleteSpinner(spinnerId) {
  const response = await makePostRequest("delete_spinner", {
    spinner_id: spinnerId,
  });

  if (!response.ok) {
    console.error(`Could not delete spinner - ${await response.text()}`);
  }

  return response.ok;
}

export async function addEntry(spinnerId, entry, visible) {
  const response = await makePostRequest("add_entry", {
    spinner_id: spinnerId,
    entry: entry,
    visible: visible,
  });

  if (!response.ok) {
    console.error(`Could not add entry - ${await response.text()}`);
  }

  return response.ok;
}

export async function deleteEntry(entryId) {
  const response = await makePostRequest("delete_entry", {
    entry_id: entryId,
  });

  if (!response.ok) {
    console.error(`Could not delete entry - ${await response.text()}`);
  }

  return response.ok;
}

export async function toggleVisible(entryId) {
  const response = await makePostRequest("toggle_visible", {
    entry_id: entryId,
  });

  if (!response.ok) {
    console.error(`Could not toggle visible - ${await response.text()}`);
  }

  return response.ok;
}

async function makeGetRequest(endpoint) {
  return fetch(`${serverLocation}/${endpoint}`);
}

async function makePostRequest(endpoint, body) {
  return fetch(`${serverLocation}/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
